import { SelectMode } from "../../../../field-settings/settings-shared/options/options-list/types.js";
function getSelectMode({
  maxItems,
  products
} = {}) {
  if (maxItems === 1) {
    return SelectMode.onlyOne;
  }
  if (products?.length && products.every(
    (product) => typeof product.quantityLimit?.maximum === "undefined"
  )) {
    return SelectMode.many;
  }
  return SelectMode.oneByOne;
}
export {
  getSelectMode
};
//# sourceMappingURL=get-select-mode.js.map
